import React from 'react';
import './Home.css';
import Product from "./Product";
    
function Home() {
  return <div className='home'>
      <div className='home__container'>
          <img className='home__image' src="https://williamsonsource.com/wp-content/uploads/2021/04/Coming-to-Amazon-Prime-Video-in-May-2021-ws.jpg" alt="" />

          <div className='home__row'>
              <Product id="123345" title='The lean startup' price={19.99} image='https://images-na.ssl-images-amazon.com/images/I/81-QB7nDh4L.jpg' rating={3} />
              <Product id="365678" title='Apple iPhone 13(256 GB Storage, Red)' price={1099.95} image='https://d2xamzlzrdbdbn.cloudfront.net/products/217333b1-d0f9-4abe-b5e7-8889a79ba90921170556_416x416.jpg' rating={4} />
          </div>

          <div className='home__row'>
              <Product id="854534" title='Titan White Dial Multifunction Watch' price={149.99} image='https://staticimg.titan.co.in/Titan/Catalog/90102WL01_1.jpg?pView=pdp' rating={4} />
              <Product id="564524" title='Pureit Copper RO Water Purifier' price={399.99} image='https://www.pureitwater.com/IN/uploads/product/55d55e438921b27785b038965fe9e382.png' rating={5} />
              <Product id="534179" title='Roadster Blue Jeans' price={29.99} image='https://img3.junaroad.com/uiproducts/16812679/pri_175_p-1639655298.jpg' rating={3} />
          </div>

          <div className='home__row'>
              <Product id="479090" title='Geeetech A10m Impresora 3d Mix Color 3d Metal Printer Dual Extruder 3D Printer' price={458} image='https://sc04.alicdn.com/kf/Hc12cc406c700440f8fefd84c940dcaf1m.jpg' rating={4} />
          </div>
      </div>
  </div>;
}

export default Home;
